import styled from 'styled-components';

const GroceriesTags = styled.div`
  position: absolute;
  top: ${({ top }) => (top ? '55px' : '35px')};
  left: -12px;
`;
export default GroceriesTags;
